export const baseState = {
  fetchProgress: false,
  fetchError: false,
  fetchItemProgress: false,
  fetchItemError: false,
  createProgress: false,
  updateProgress: false,
  deleteProgress: false,

  items: [],

  itemId: null,
  item: null,
};

export const baseActions = {
  fetchItems() {},
  fetchItem() {},
  createItem() {},
  updateItem() {},
  deleteItem() {},

  setItemId({ commit }, id) {
    if (id) {
      commit('setItemId', id);
    } else {
      commit('setItemId', null);
      commit('setItem', null);
    }
  },
};

export const baseMutations = {
  setFetchProgress(state, bool) {
    state.fetchProgress = bool;
  },
  setFetchItemProgress(state, bool) {
    state.fetchItemProgress = bool;
  },
  setCreateProgress(state, bool) {
    state.createProgress = bool;
  },
  setUpdateProgress(state, bool) {
    state.updateProgress = bool;
  },
  setDeleteProgress(state, bool) {
    state.deleteProgress = bool;
  },

  setFetchError(state, bool) {
    state.fetchError = bool;
  },
  setFetchItemError(state, bool) {
    state.fetchItemError = bool;
  },
  setItems(state, items) {
    state.items = items;
  },

  setItemId(state, id) {
    state.itemId = id;
  },
  setItem(state, item) {
    state.item = item;
  },
};

export const baseGetters = {
  fetchProgress: (state) => state.fetchProgress,
  fetchItemProgress: (state) => state.fetchItemProgress,
  createProgress: (state) => state.createProgress,
  updateProgress: (state) => state.updateProgress,
  deleteProgress: (state) => state.deleteProgress,
  fetchError: (state) => state.fetchError,
  fetchItemError: (state) => state.fetchItemError,
  actionProgress: (state) => state.createProgress || state.updateProgress || state.deleteProgress,
  items: (state) => state.items,
  itemId: (state) => state.itemId,
  item: (state) => state.item,
};
